import React from 'react';

import useClassy from '@core/hooks/useClassy';

import classes from './TypingIndicator.module.scss';

interface TypingIndicatorProps {
  show?: boolean;
}

export default function TypingIndicator({ show = true }: TypingIndicatorProps) {
  const bem = useClassy(classes, 'TypingIndicator');

  if (!show) return null;

  return (
    <div className={bem('&', 'owlbot-typing-indicator')}>
      <div className={bem('-generatingText')}>
        Generating
        <div className={bem('-generatingDotsWrapper')}>
          <div className={bem('-generatingDots')}>.</div>
          <div className={bem('-generatingDots')}>.</div>
          <div className={bem('-generatingDots')}>.</div>
        </div>
      </div>
    </div>
  );
}
